import { render, staticRenderFns } from "./WorkshopConfirmacao.vue?vue&type=template&id=49fc2db5&scoped=true&"
import script from "./WorkshopConfirmacao.vue?vue&type=script&lang=js&"
export * from "./WorkshopConfirmacao.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopConfirmacao.vue?vue&type=style&index=0&id=49fc2db5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fc2db5",
  null
  
)

export default component.exports